import { render, staticRenderFns } from "./AccordionFilterInputSuggest.vue?vue&type=template&id=fa661540"
import script from "./AccordionFilterInputSuggest.vue?vue&type=script&lang=js"
export * from "./AccordionFilterInputSuggest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports